import React, { Fragment, MouseEventHandler } from 'react'
import { Box, Toolbar } from '@mui/material'

import ArrowBackIcon from '../../assets/icons/ArrowBackIcon'
import WidgetButton, {
  WidgetButtonProps,
  WidgetButtonType,
} from './WidgetButton'

interface ActionBarProps {
  backLabel: string
  backAction?: MouseEventHandler<HTMLButtonElement>
  otherActions?: Array<WidgetButtonProps>
}

const ActionBar = (props: ActionBarProps) => {
  return (
    <Toolbar
      sx={theme => ({
        marginBottom: theme.spacing(2.5),
        display: 'flex',
        justifyContent: 'space-between',
        '&.MuiToolbar-root': {
          minHeight: 'initial',
          padding: '0',
        },
      })}
    >
      {/* Nav actions */}
      <Box>
        <WidgetButton
          label={props.backLabel}
          action={props.backAction}
          type={WidgetButtonType.Nav}
          icon={<ArrowBackIcon />}
        />
      </Box>
      {/* Page actions */}
      {props.otherActions?.length && (
        <Box
          sx={theme => ({
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(0.5),
          })}
        >
          {props.otherActions.map(
            (buttonProps: WidgetButtonProps, index: number, otherActions) => (
              <Fragment key={buttonProps.label}>
                <WidgetButton type={WidgetButtonType.Action} {...buttonProps} />
                {index < otherActions.length - 1 && (
                  <span
                    style={{ fontSize: '1rem', color: 'rgba(0, 0, 0, 0.4)' }}
                  >
                    {' '}
                    |{' '}
                  </span>
                )}
              </Fragment>
            ),
          )}
        </Box>
      )}
    </Toolbar>
  )
}

ActionBar.defaultProps = {
  backLabel: 'back',
}

export default ActionBar
